<template>
  <main-layout>
    <update-recurrent-intervention-dialog
      v-model="isUpdateRecurrentInterventionDialogOpened"
      :recurrentIntervention="recurrentInterventionToUpdate"
      @updated="fetchRecurrentInterventions"
      @removed="fetchRecurrentInterventions"
    />
    <new-recurrent-intervention-dialog
      v-model="isNewRecurrentInterventionDialogOpened"
      :maker="newRecurrentInterventionMaker"
      :client="newRecurrentInterventionClient"
      @added="fetchRecurrentInterventions"
    />
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Interventions récurrentes</span>
      <v-spacer></v-spacer>
      <v-btn dark color="primary" elevation="0" @click="isNewRecurrentInterventionDialogOpened = true">
        <v-icon left>add</v-icon>
        Nouvelle récurrence
      </v-btn>
    </v-row>
    <div class="relative">
      <v-row no-gutters justify="center" align="center" class="py-8" style="min-height: 100px;" v-if="isFetchingRecurrentInterventions">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
          class="absolute-progress"
        ></v-progress-linear>
      </v-row>
      <n-card v-else-if="!recurrentInterventions.length">
        <v-row
          no-gutters
          justify="center"
          align="center"
          class="pa-4 text--secondary"
          style="min-height: 100px;"
        >
          Vous n'avez encore aucune intervention récurrente
        </v-row>
      </n-card>
      <template v-else>
        <recurrent-intervention-card
          v-for="recurrentIntervention in recurrentInterventions"
          :key="recurrentIntervention.id"
          :value="recurrentIntervention"
          clickable
          @click="recurrentInterventionToUpdate = recurrentIntervention"
          class="mb-4"
        />
      </template>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/views/settings/MainLayout.vue';
import RecurrentInterventionCard from '@/components/RecurrentInterventions/Card.vue';
import NewRecurrentInterventionDialog from '@/components/RecurrentInterventions/NewDialog.vue';
import UpdateRecurrentInterventionDialog from '@/components/RecurrentInterventions/UpdateDialog.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  data: () => ({
    isNewRecurrentInterventionDialogOpened: false,
    newRecurrentInterventionClient: null,
    recurrentInterventionToUpdate: null,
  }),

  computed: {
    ...mapState(`model/client`, [
      `company`,
    ]),
    ...mapGetters(`ui/settingsRecurrentInterventions`, [
      `recurrentInterventions`,
      `isFetchingRecurrentInterventions`,
    ]),
    newRecurrentInterventionMaker() {
      return this.company;
    },
    isUpdateRecurrentInterventionDialogOpened: {
      get() { return this.recurrentInterventionToUpdate !== null; },
      set() { this.recurrentInterventionToUpdate = null; },
    },
  },

  methods: {
    ...mapActions(`ui/settingsRecurrentInterventions`, [
      `fetchRecurrentInterventions`,
    ]),
  },

  beforeMount() {
    this.fetchRecurrentInterventions();
  },

  components: {
    MainLayout,
    RecurrentInterventionCard,
    NewRecurrentInterventionDialog,
    UpdateRecurrentInterventionDialog,
  },
};
</script>
